import React, { forwardRef } from 'react';
import Slider from 'react-slick';
import { SliderInstance } from '../SliderInstance';

interface Skill {
  name: string;
  skillType: string;
  starCount: number;
}

interface SkillSliderContentProps {
  skills: Skill[];
  handleSkillClick: (skill: Skill) => void;
  sliderSettings: any;
}

export const SkillSliderContent = forwardRef<any, SkillSliderContentProps>(
  ({ skills, handleSkillClick, sliderSettings }, ref) => {
    const handlePrev = () => {
      // @ts-ignore
      ref.current?.slickPrev();
    };

    const handleNext = () => {
      // @ts-ignore
      ref.current?.slickNext();
    };

    return (
      <div
        data-delay={4000}
        data-animation="slide"
        className="slider-9 w-slider"
        data-autoplay="false"
        data-easing="ease"
        data-hide-arrows="false"
        data-disable-swipe="false"
        data-autoplay-limit={0}
        data-nav-spacing={3}
        data-duration={500}
        data-infinite="true"
      >
        <div className="mask w-slider-mask">
          <Slider.default ref={ref} {...sliderSettings}>
            {skills.map((skill, index) => (
              <SliderInstance
                key={index}
                skillName={skill.name}
                skillType={skill.skillType}
                starCount={skill.starCount}
                openPopup={() => handleSkillClick(skill)}
              />
            ))}
          </Slider.default>
        </div>
        <div className="left-arrow w-slider-arrow-left" onClick={handlePrev}>
          <img
            src="/images/prev.png"
            loading="lazy"
            alt=""
            className="image-160"
          />
        </div>
        <div
          className="right-arrow-8 w-slider-arrow-right"
          onClick={handleNext}
        >
          <img
            src="/images/next.png"
            loading="lazy"
            alt=""
            className="image-176"
          />
        </div>
        <div className="slide-nav-4 w-slider-nav w-round" />
      </div>
    );
  }
);
